import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import CustomDialog from '../../common/custom-dialog/custom-dialog';
import { Money } from '../../../utils/money';
import MoneyInput from '../../common/money-input/money-input';
import { OrderType } from '../../../interfaces/delivery-company/orders';
import { get_cod } from '../../../utils/cod';
import { DriverType } from '../../../interfaces/delivery-company/drivers';

interface UpdateDriverCommissionProps {
  onSubmit: (m: Money[]) => void;
  onClose: () => void;
  orders: OrderType[];
  defaultCommission: Money[];
  driver: DriverType;
}

function UpdateDriverCommission({
  onSubmit,
  onClose,
  orders,
  driver,
}: UpdateDriverCommissionProps) {
  const [commission, setCommission] = useState<Money[]>([]);

  const handleSubmit = () => {
    onSubmit(commission);
    onClose();
  };

  const handleReset = () => setCommission(driver.default_commission);

  return (
    <CustomDialog open={true} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Driver Commission for{' '}
        {orders.length < 3
          ? `orders: ${orders.map((item) => item.order_id).join(', ')}`
          : `${orders.length} orders`}
      </DialogTitle>
      <DialogContent>
        <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
          Suggested Actions
        </Typography>
        {/* Suggestion Buttons */}
        <Stack direction="row" spacing={1} flexWrap="wrap">
          <Button
            size="small"
            variant="outlined"
            onClick={handleReset}
            sx={{ textTransform: 'none', borderRadius: 2 }}
          >
            Reset to Default
          </Button>
        </Stack>

        <br />
        <MoneyInput
          money={commission}
          setMoney={setCommission}
          label="Driver Commission"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSubmit}>
          Save
        </Button>
      </DialogActions>
    </CustomDialog>
  );
}

export default UpdateDriverCommission;
